import { EmailAddress } from "@models/clients/emailAddress";
import { ClientCRMRepo } from "@services/clients/clientCRM.repo";

class NewEmailAddressController {
  public emailAddress: EmailAddress;
  public client: any;
  public isLoading: boolean = false;
  public isEditMode: boolean = false;
  public emailAddressForm: angular.IFormController;

  /** @ngInject */
  constructor(
    private $mdDialog: angular.material.IDialogService,
    private clientCRMRepo: ClientCRMRepo
  ) {}

  $onInit() {
    // Initialize email address object - create a copy to avoid modifying the original
    if (this.emailAddress) {
      this.emailAddress = { ...this.emailAddress }; // Create a shallow copy
      this.isEditMode = this.emailAddress.id > 0;
    } else {
      this.emailAddress = { 
        id: 0, 
        email: ''
      };
      this.isEditMode = false;
    }
  }

  public saveEmailAddress() {
    // Trigger form validation
    this.emailAddressForm.$setSubmitted();
    
    // Check if form is valid
    if (this.emailAddressForm.$invalid) {
      return;
    }

    this.isLoading = true;
    
    // Call the saveEmailAddress endpoint - backend will determine if it's create or update based on the ID
    this.clientCRMRepo.saveEmailAddress(this.client.id, this.emailAddress)
      .then((result) => {
        this.$mdDialog.hide(this.emailAddress);
      })
      .catch((error) => {
        console.error('Error saving email address:', error);
        // You could add error handling/notification here
        this.isLoading = false;
      });
  }

  public cancel() {
    this.$mdDialog.cancel();
  }
}

export const newEmailAddressModal: angular.IComponentOptions = {
  template: require('./new-email-address.modal.html'),
  controller: NewEmailAddressController,
  controllerAs: '$ctrl',
  bindings: {
    emailAddress: '<',
    client: '<'
  }
};



// WEBPACK FOOTER //
// ./src/app/clients/clients.details/profile/modals/new-email-address.modal.ts